/**
 * Breakpoints responsivos para o projeto
 * Valores baseados em pixels para controle de layout em diferentes tamanhos de tela
 */

export const BREAKPOINTS = {
	// Breakpoint para dispositivos móveis muito pequenos
	MOBILE_XS: 384,

	// Breakpoint para dispositivos móveis pequenos
	MOBILE_SMALL: 444,

	// Breakpoint para dispositivos móveis médios
	MOBILE_MEDIUM: 571,

	// Breakpoint para dispositivos móveis grandes
	MOBILE_LARGE: 575,

	// Breakpoint para tablets pequenos
	TABLET_SMALL: 576,

	// Breakpoint para tablets médios
	TABLET: 767,

	// Breakpoint para tablets grandes
	TABLET_LARGE: 768,

	// Breakpoint para desktops pequenos
	DESKTOP_SMALL: 820,

	// Breakpoint para tablets/desktops pequenos
	DESKTOP_TABLET: 991,

	// Breakpoint para desktops médios pequenos
	DESKTOP_MEDIUM_SMALL: 992,

	// Breakpoint para desktops médios
	DESKTOP_MEDIUM: 1210,

	// Breakpoint para desktops grandes
	DESKTOP_LARGE: 1335,

	// Breakpoint para desktops muito grandes
	DESKTOP_XL: 1400,
} as const;

/**
 * Nomes descritivos para os breakpoints para uso em comentários e documentação
 */
export const BREAKPOINT_NAMES = {
	[BREAKPOINTS.MOBILE_SMALL]: "MOBILE_SMALL",
	[BREAKPOINTS.MOBILE_MEDIUM]: "MOBILE_MEDIUM",
	[BREAKPOINTS.TABLET]: "TABLET",
	[BREAKPOINTS.DESKTOP_SMALL]: "DESKTOP_SMALL",
	[BREAKPOINTS.DESKTOP_MEDIUM]: "DESKTOP_MEDIUM",
	[BREAKPOINTS.DESKTOP_LARGE]: "DESKTOP_LARGE",
} as const;

export type BreakpointKey = keyof typeof BREAKPOINTS;
export type BreakpointValue = (typeof BREAKPOINTS)[BreakpointKey];
